/**
 * Decorative separator rendered above a subsection when it's not the first
 * one in its section. Style presets are whitelisted server-side.
 *
 * - line   (default) thin static-neutral 1px rule
 * - dashed / dotted  same weight, textured
 * - double           two parallel lines with a gap
 * - accent           bold 2px line in the subsection's color
 * - glyph            three centered marks flanked by short rules
 * - none             render nothing (tightly linked sub-sections)
 */
export default function SubsectionDivider({ style = "line", color = "#283524" }) {
  if (style === "none") return null;

  if (style === "accent") {
    return (
      <div
        aria-hidden="true"
        className="my-6"
        style={{ height: 2, background: color }}
      />
    );
  }

  if (style === "double") {
    return (
      <div aria-hidden="true" className="my-6 space-y-1">
        <div style={{ height: 1, background: color }} />
        <div style={{ height: 1, background: color }} />
      </div>
    );
  }

  if (style === "glyph") {
    return (
      <div
        aria-hidden="true"
        className="my-8 flex items-center gap-3 font-mono-ui text-xs tracking-[0.4em]"
        style={{ color }}
      >
        <span className="flex-1 h-px" style={{ background: color }} />
        <span>· ✦ ·</span>
        <span className="flex-1 h-px" style={{ background: color }} />
      </div>
    );
  }

  // dashed / dotted / line — CSS border variant
  const borderStyle = style === "dashed" ? "dashed" : style === "dotted" ? "dotted" : "solid";
  return (
    <div
      aria-hidden="true"
      className="my-6"
      style={{ borderTop: `1px ${borderStyle} ${color}` }}
    />
  );
}
